/* SessionListItem.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._42Yu6B7dHp%7Bz-index%3A1%7D%0A._0bjKvDyzSk%7Bborder-radius%3Avar(--ds-radius-xlarge%2C9pt)%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._0Of8r28HPE%7Bpadding-top%3Avar(--ds-space-150%2C9pt)%7D%0A._03SyCP8HPE%7Bpadding-inline-end%3Avar(--ds-space-150%2C9pt)%7D%0A._1wydGW8HPE%7Bpadding-bottom%3Avar(--ds-space-150%2C9pt)%7D%0A._0LQT5E8HPE%7Bpadding-inline-start%3Avar(--ds-space-150%2C9pt)%7D%0A._0KLXru66of%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D%0A._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._2fwxA57p2s%7Btext-align%3Astart%7D%0A._0bjKvDKTcp%7Bborder-radius%3Avar(--ds-radius-medium%2C6px)%7D%0A._0LQT5E2ADO%7Bpadding-inline-start%3Avar(--ds-space-100%2C8px)%7D%0A._1eOmH6o126%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D%0A._3gzVzLJNoT%3Aactive%7Bbackground-color%3Avar(--ds-surface-pressed%2C%23dddee1)%7D%0A._0KLXruo126%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D%0A._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._1UtDYzjTy9%7Bcolor%3Avar(--ds-text-selected%2C%231868db)%7D%0A._1eOmH6sumd%3Ahover%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D%0A._3gzVzLXsxn%3Aactive%7Bbackground-color%3Avar(--ds-background-selected-pressed%2C%238fb8f6)%7D%0A._0KLXrusumd%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._1ZB6UydnbC%7Binset-block-end%3A0%7D%0A._1VJPcaykWR%7Btransform%3AtranslateY(100%25)%7D%0A._3iC0zd8HPE%7Binset-inline-start%3Avar(--ds-space-150%2C9pt)%7D%0A._1OKFqY8HPE%7Binset-inline-end%3Avar(--ds-space-150%2C9pt)%7D%0A._1pp6NdYbGa%7Bpointer-events%3Anone%7D%0A._3hhsrrNvrM%7Bborder-bottom-width%3Avar(--ds-border-width%2C1px)%7D%0A._3BoeID6wH8%7Bborder-bottom-style%3Asolid%7D%0A._3XVgLM9r67%7Bborder-bottom-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._3iC0zdgVvo%7Binset-inline-start%3Avar(--ds-space-075%2C6px)%7D%0A._1OKFqYgVvo%7Binset-inline-end%3Avar(--ds-space-075%2C6px)%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._0Of8r2dnbC%7Bpadding-top%3A0%7D%0A._1ZnuxbdnbC%7Bpadding-right%3A0%7D%0A._1wydGWdnbC%7Bpadding-bottom%3A0%7D%0A._2Zuz6QdnbC%7Bpadding-left%3A0%7D%0A._2I62gzdnbC%7Binset-block-start%3A0%7D%0A._3iC0zddnbC%7Binset-inline-start%3A0%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._0KLXrujOvk%7Bbackground-color%3Atransparent%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._39xV02oWWg%7Bwidth%3A24px%7D%0A._0jFU0VoWWg%7Bheight%3A24px%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._39xV02Z49V%7Bwidth%3A2rem%7D%0A._1UtDYzZpcK%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D%0A._39xV02ey7F%7Bwidth%3A1pc%7D%0A._0jFU0Vey7F%7Bheight%3A1pc%7D%0A._1VJPcagSbW%7Btransform%3Ascale(.9375)%7D%0A._0yKXXaDIqT%7Btransform-origin%3Acenter%7D%0A._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._2IhTon715P%7Btop%3A50%25%7D%0A._0jFU0VZ49V%7Bheight%3A2rem%7D%0A._1VJPcaxoyV%7Btransform%3Atranslate(-1px%2C-50%25)%7D%0A._1YKVNsdnbC%7Bopacity%3A0%7D%0A._03SyCPVa5s%7Bpadding-inline-end%3Avar(--ds-space-400%2C2pc)%7D%0A._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D%0A._03SyCPp0Oa%7Bpadding-inline-end%3Avar(--ds-space-600%2C3pc)%7D%0A._1VJPcakruI%7Btransform%3AtranslateY(-50%25)%7D%0A._1YKVNs7dHp%7Bopacity%3A1%7D");
































































import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import PinFilledIcon from '@atlaskit/icon/core/pin-filled';
import { useIsReducedMotion } from '@atlaskit/motion/use-is-reduced-motion';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { WidthObserver } from '@atlaskit/width-detector/width-observer';
import type { AgentSessionState } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { isLinkableSessionContext } from '../session-details/isLinkableSessionContext';
import { SessionAgent } from '../session-details/SessionAgent';
import { SessionContext, type SessionContextItem } from '../session-details/SessionContext';
import { SessionDetailsList } from '../session-details/SessionDetailsList';
import { SessionLastUpdated } from '../session-details/SessionLastUpdated';
import { SessionStatusIndicator } from '../session-details/SessionStatusIndicator';
import { SessionStatusInline } from '../session-details/SessionStatusInline';
import { SessionTextTransition } from '../session-details/SessionTextTransition';
import { SessionTitle } from '../session-details/SessionTitle';
import messages from './messages';
import { SessionListItemCompactContext } from './SessionListItemCompactContext';
const COMPACT_WIDTH_BREAKPOINT = 480;
const styles = {
  item: "_1mT5xdRAKS",
  highlightedItem: "_42Yu6B7dHp",
  row: "_0bjKvDyzSk _3iDTPbvLZJ _39xV02N91d _24h04i2Njc _0Of8r28HPE _03SyCP8HPE _1wydGW8HPE _0LQT5E8HPE _0KLXru66of _1UtDYzy7kJ _2fwxA57p2s",
  compactRow: "_0bjKvDKTcp _0LQT5E2ADO",
  interactiveRow: "_1eOmH6o126 _3gzVzLJNoT",
  hoveredRow: "_0KLXruo126",
  selectedRow: "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _3gzVzLXsxn",
  selectedHoveredRow: "_0KLXrusumd",
  divider: "_1mT5xdWVPG _1ZB6UydnbC _1VJPcaykWR _3iC0zd8HPE _1OKFqY8HPE _42Yu6B7dHp _1pp6NdYbGa _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
  compactDivider: "_3iC0zdgVvo _1OKFqYgVvo",
  content: "_4ouGXIdnbC",
  activationOverlay: "_0bjKvDyzSk _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1mT5xdWVPG _2I62gzdnbC _3iC0zddnbC _39xV02N91d _0jFU0VN91d _0KLXrujOvk",
  compactActivationOverlay: "_0bjKvDKTcp",
  contentAboveActivation: "_1pp6NdYbGa",
  compactText: "_3YEZNOdnbC",
  trailing: "_3YEZNOdnbC",
  indicatorPlaceholder: "_39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC",
  pinnedIndicator: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _1UtDYzZpcK _3YEZNOdnbC",
  pinnedIndicatorIcon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _1VJPcagSbW _0yKXXaDIqT",
  compactTrailing: "_1mT5xdWVPG _1OKFqYPgdg _2IhTon715P _39xV02Z49V _0jFU0VZ49V _37wbyuDIqT _1VJPcaxoyV",
  statusHidden: "_1YKVNsdnbC",
  compactWithActions: "_03SyCPVa5s",
  compactContentWithActions: "_03SyCP1Y8M",
  withActions: "_03SyCPp0Oa",
  actions: "_1mT5xdWVPG _42Yu6B7dHp _1OKFqY8HPE _2IhTon715P _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Z49V _0jFU0VZ49V _1VJPcakruI",
  compactActions: "_1OKFqYPgdg _1VJPcaxoyV",
  actionsHidden: "_1YKVNsdnbC _1pp6NdYbGa",
  actionsVisible: "_1YKVNs7dHp"
};

/**
 * Presentation data accepted directly from normalized agent sessions.
 * Deliberately independent of Relay records and fetching hooks.
 */
export type SessionListSession = Readonly<{
  id: string;
  conversationChannel?: Readonly<{
    id?: string;
    name?: string;
    readStatus?: boolean | null;
    isPinned?: boolean | null;
    pinnedAt?: number | null;
  }>;
  /** Presentation fallback for sessions that do not have a conversation channel. */
  title?: string;
  state?: AgentSessionState | (string & {});
  /** Raw identity data interpreted by SessionAgent. */
  displayAgent?: Readonly<{
    id: string;
    name: string;
    avatarUrl?: string;
    isRovo?: boolean;
    agentId?: string;
    agentIdentityAccountId?: string;
    agentNamedId?: string;
  }>;
  /** Associated context data, in display priority order. */
  contexts?: readonly SessionContextItem[];
  /** Time of the latest state change, in epoch milliseconds. */
  lastStateChangeAt?: number;
}>;
export type SessionListItemProps = Readonly<{
  /** Normalized data for the session represented by this row. */
  session: SessionListSession;
  /** Enables one whole-row activation target. The caller owns the resulting action. */
  onActivate?: React.MouseEventHandler<HTMLButtonElement>;
  /** Opens file and image contexts in a caller-owned preview. */
  onFilePreview?: (fileUrl: string, fileName: string) => void;
  /** Optional host-owned controls, rendered beside the row activation target. */
  actions?: React.ReactNode;
  /** Keeps the action trigger visible while its portaled menu is open. */
  isActionsOpen?: boolean;
  /** Whether the list should show a divider after this row. */
  hasDivider?: boolean;
  /** Always use the compact layout regardless of available width. Defaults to false. */
  forceCompact?: boolean;
  /** Whether this is the currently selected session. */
  isSelected?: boolean;
  testId?: string;
}>;
const getSessionListItemStatus = (session: SessionListItemProps['session']): React.ComponentProps<typeof SessionStatusIndicator>['status'] => {
  if (session.state === 'WORKING') {
    return 'working';
  }
  if (session.state === 'INPUT_REQUIRED' || session.state === 'AUTH_REQUIRED') {
    return 'needs-input';
  }
  if (session.conversationChannel?.readStatus === false) {
    return 'unread';
  }
  return undefined;
};

/** Responsive row presentation shared by SessionList and other session navigation surfaces. */
export const SessionListItem = ({
  session,
  onActivate,
  onFilePreview,
  actions,
  isActionsOpen = false,
  forceCompact = false,
  hasDivider,
  isSelected,
  testId
}: SessionListItemProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [isNarrow, setIsNarrow] = useState(false);
  const isCompact = forceCompact || isNarrow;
  const [isHovered, setIsHovered] = useState(false);
  const [hasFocusWithin, setHasFocusWithin] = useState(false);
  const handleWidthChange = useCallback((width: number) => {
    setIsNarrow(width < COMPACT_WIDTH_BREAKPOINT);
  }, []);
  const title = (session.conversationChannel == null ? session.title?.trim() : session.conversationChannel.name?.trim()) || formatMessage(messages.sessionTitle);
  const status = getSessionListItemStatus(session);
  const isAiInboxEnabled = fg('rovo-chat-ai-inbox');
  const isUnread = session.conversationChannel?.readStatus === false;
  const isPinned = session.conversationChannel?.isPinned === true;
  const indicatorStatus = isAiInboxEnabled && status === 'needs-input' ? isUnread ? 'unread' : undefined : status;
  const hasStatus = status !== undefined;
  const hasActions = Boolean(actions);
  const areActionsVisible = isHovered || hasFocusWithin || isActionsOpen;
  const activationLabel = formatMessage(isAiInboxEnabled && indicatorStatus === 'unread' ? status === 'needs-input' ? messages.openUnreadSessionNeedsInputLabel : messages.openUnreadSessionLabel : status === 'needs-input' ? messages.openSessionNeedsInputLabel : status === 'working' ? messages.openSessionWorkingLabel : messages.openSessionLabel, {
    title
  });
  const contexts = session.contexts?.filter(isLinkableSessionContext);
  const hasContextLink = Boolean(contexts?.length);
  const hasPersistentStatus = status === 'working' || status === 'needs-input';
  const hasMounted = useRef(false);
  useEffect(() => {
    hasMounted.current = true;
  }, []);
  const reducedMotion = useIsReducedMotion();
  const [retainStatusText, setRetainStatusText] = useState(hasPersistentStatus);
  useEffect(() => {
    if (hasPersistentStatus || reducedMotion) {
      setRetainStatusText(hasPersistentStatus);
      return;
    }
  }, [hasPersistentStatus, reducedMotion]);
  const handleTextExitComplete = useCallback(() => setRetainStatusText(false), []);
  const hasTextSlot = hasPersistentStatus || !reducedMotion && retainStatusText;
  const displayAgent = session.displayAgent?.isRovo ? undefined : session.displayAgent;
  const hasMetadata = Boolean(isCompact && hasTextSlot || displayAgent || contexts?.length || session.lastStateChangeAt != null);
  const content = <Inline alignBlock="center" space="space.200" spread="space-between" xcss={hasActions && isCompact && styles.compactContentWithActions}>
			<Stack grow="fill" space="space.050" xcss={styles.content}>
				<SessionTitle truncate>{title}</SessionTitle>
				{hasMetadata ? <SessionDetailsList testId={testId ? `${testId}-details` : undefined} firstItemOwnsSeparator={isCompact && Boolean(hasTextSlot || displayAgent)}>
						{isCompact && (hasTextSlot || displayAgent) ? <Inline as="span" alignBlock="center" space="space.050" shouldWrap={false} xcss={styles.compactText}>
								{displayAgent ? <SessionAgent agents={[displayAgent]} showNames={false} iconSize={16} /> : null}
								<SessionTextTransition shouldAnimateOnMount={hasMounted.current && hasPersistentStatus} transitionKey={hasPersistentStatus ? status : 'agent'} trailingSeparator={Boolean(contexts?.length || session.lastStateChangeAt != null)} onExitComplete={handleTextExitComplete}>
									{hasPersistentStatus ? <SessionStatusInline status={status === 'working' ? 'working' : 'needs-input'} showIcon={false} textSize="small" /> : displayAgent?.name}
								</SessionTextTransition>
							</Inline> : displayAgent ? <SessionAgent agents={[displayAgent]} showNames iconSize={16} /> : null}
						{contexts?.length ? <SessionContext contexts={contexts} onFilePreview={onFilePreview} truncate /> : null}
						{session.lastStateChangeAt != null ? <SessionLastUpdated lastStateChangeAt={session.lastStateChangeAt} /> : null}
					</SessionDetailsList> : null}
			</Stack>
			{hasStatus || hasTextSlot && !isCompact || isPinned ? <Inline as="span" alignBlock="center" space="space.150" xcss={cx(styles.trailing, hasActions && isCompact && styles.compactTrailing, hasActions && isCompact && areActionsVisible && styles.statusHidden)} testId={testId ? `${testId}-status` : undefined}>
					{!isCompact ? <SessionTextTransition align="end" onExitComplete={handleTextExitComplete} shouldAnimateOnMount={hasMounted.current} transitionKey={status}>
							{hasPersistentStatus ? <SessionStatusInline status={status === 'working' ? 'working' : 'needs-input'} showIcon={false} textSize="default" /> : null}
						</SessionTextTransition> : null}
					{isAiInboxEnabled && status === 'needs-input' && !isUnread ? <Box as="span" xcss={styles.indicatorPlaceholder} aria-hidden="true" /> : <SessionStatusIndicator status={indicatorStatus} decorative={hasPersistentStatus && indicatorStatus !== 'unread'} testId={testId ? `${testId}-indicator` : undefined} />}
					{isPinned ? <Box as="span" xcss={styles.pinnedIndicator} aria-hidden="true" testId={testId ? `${testId}-pinned-indicator` : undefined}>
							<Box as="span" xcss={styles.pinnedIndicatorIcon}>
								<PinFilledIcon label="" color="currentColor" size="small" />
							</Box>
						</Box> : null}
				</Inline> : null}
		</Inline>;
  return <Box role="listitem" xcss={cx(styles.item, (isHovered || isSelected) && styles.highlightedItem)} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onFocusCapture={() => setHasFocusWithin(true)} onBlurCapture={(event: React.FocusEvent<HTMLDivElement>) => {
    if (!event.currentTarget.contains((event.relatedTarget as Node | null))) {
      setHasFocusWithin(false);
    }
  }}>
			<WidthObserver setWidth={handleWidthChange} />
			{hasDivider && !isHovered && !isSelected && <Box aria-hidden="true" xcss={cx(styles.divider, isCompact && styles.compactDivider)} />}
			{onActivate && hasContextLink ? <Box xcss={cx(styles.row, isCompact && styles.compactRow, styles.interactiveRow, isSelected && styles.selectedRow, isHovered && !isSelected && styles.hoveredRow, isHovered && isSelected && styles.selectedHoveredRow, hasActions && (isCompact ? styles.compactWithActions : styles.withActions))}>
					<Pressable xcss={cx(styles.activationOverlay, isCompact && styles.compactActivationOverlay)} onClick={onActivate} aria-label={activationLabel} aria-current={isSelected ? 'page' : undefined} testId={testId} />
					<Box xcss={styles.contentAboveActivation}>{content}</Box>
				</Box> : onActivate ? <Pressable xcss={cx(styles.row, isCompact && styles.compactRow, styles.interactiveRow, isSelected && styles.selectedRow, isHovered && !isSelected && styles.hoveredRow, isHovered && isSelected && styles.selectedHoveredRow, hasActions && (isCompact ? styles.compactWithActions : styles.withActions))} onClick={onActivate} aria-label={activationLabel} aria-current={isSelected ? 'page' : undefined} testId={testId}>
					{content}
				</Pressable> : <Box xcss={cx(styles.row, isCompact && styles.compactRow, isSelected && styles.selectedRow, hasActions && (isCompact ? styles.compactWithActions : styles.withActions))} testId={testId}>
					{content}
				</Box>}
			{actions && <Box xcss={cx(styles.actions, isCompact && styles.compactActions, areActionsVisible ? styles.actionsVisible : styles.actionsHidden)} testId={testId ? `${testId}-actions` : undefined}>
					<SessionListItemCompactContext.Provider value={isCompact}>
						{actions}
					</SessionListItemCompactContext.Provider>
				</Box>}
		</Box>;
};